import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class APIInterceptorService implements HttpInterceptor {
  private getApiURL() {
    if (environment.apiUrl !== null) {
      return environment.apiUrl;
    } else {
      if (location.host.includes("localhost")) {
        return "https://dev.ripsim.com";
      } else {
        return `https://${location.host}`;
      }
    }
  }

  intercept(request: HttpRequest<any>, callback: HttpHandler) {
    if (request.url.includes("/api/") && !request.url.includes("http")) {
      return callback.handle(
        request.clone({
          url: `${this.getApiURL()}${request.url}`
        })
      );
    } else {
      return callback.handle(request);
    }
  }
}
